import { SxProps, Theme } from "@mui/material";

export const getTranscriptContainerStyles =
  (isOpen: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    position: "absolute",
    right: 0,
    background: theme.palette.mode == "dark" ? "rgb(20, 20, 20)" : "white",
    boxSizing: "border-box",
    overflowY: "auto",
    zIndex: 2000,
    transition: "transform 0.4s ease-in-out",
    display: "flex",
    alignItems: "stretch",
    gap: "15px",

    [theme.breakpoints.up("sm")]: {
      top: 0,
      width: "20em",
      maxWidth: "100%",
      height: "100%",
      padding: "20px 10px",
      borderLeftWidth: "2px",
      borderLeftStyle: "solid",
      borderLeftColor: theme.palette.primary.main,
      transform: isOpen ? "translateX(0)" : "translateX(100%)",
      flexDirection: "row",
    },

    [theme.breakpoints.down("sm")]: {
      top: "auto",
      bottom: 0,
      height: "20em",
      maxHeight: "70%",
      width: "100%",
      padding: "10px 40px",
      borderTopWidth: "2px",
      borderTopStyle: "solid",
      borderTopColor: theme.palette.primary.main,
      transform: isOpen ? "translateY(0)" : "translateY(100%)",
      flexDirection: "column",
    },
  });

export const transcriptStyles: SxProps = {
  fontWeight: 500,
  cursor: "auto",
  userSelect: "text",
};
